import * as certificateTypes from './headCertificateTypes'
import useHeadCertificate from './useHeadCertificate'
import MyTextfield from '../../../../control/textfield/textfield'
import { textRequired, validateEN } from '../../../../utilities/validate'
import React from 'react'
import { Grid } from '@material-ui/core'
import useTranslate from '../../../../i18n/useTranslate'

//View
const CertificateView = (props: certificateTypes.CertificateViewType) => {
    const { disabled = false, language, onChangTextField, textRemaining } = props
    const translate = useTranslate()

    return (
        <React.Fragment>
            <Grid container spacing={2} justify={'flex-end'}>
                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`projectName${language}`}
                        materialInputProps={{
                            disabled: disabled,
                            label:
                                language === 'TH'
                                    ? `${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                            placeholder:
                                language === 'TH'
                                    ? `${translate.get('LABEL.FILL_PROJECT_NAME')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.FILL_PROJECT_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                            size: 'small',
                            rows: 5,
                            multiline: true,
                        }}
                        validates={
                            language === 'TH'
                                ? [textRequired(translate.get('MESSAGE.M015'))]
                                : [validateEN(translate.get('MESSAGE.M001'))]
                        }
                        required
                        handleValueChange={(val) => {
                            onChangTextField(val, language)
                        }}
                        maxLength={500}
                    />
                </Grid>
                {!disabled && (
                    <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'end', marginTop: '-22px' }}>
                        <small>
                            {translate.get('LABEL.NUMBER_OF_CHARACTERS')} :{' '}
                            {language === 'TH' ? textRemaining?.TH : textRemaining?.EN}
                        </small>
                    </Grid>
                )}

                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`name${language}`}
                        materialInputProps={{
                            disabled: disabled,
                            label:
                                language === 'TH'
                                    ? `${translate.get('LABEL.RESEARCHER_FL_NAME')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.RESEARCHER_FL_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                            placeholder:
                                language === 'TH'
                                    ? `${translate.get('LABEL.RESEARCHER_FL_NAME')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.RESEARCHER_FL_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                            size: 'small',
                            rows: 3,
                            multiline: true,
                        }}
                        validates={
                            language === 'TH'
                                ? [textRequired(translate.get('MESSAGE.M015'))]
                                : [validateEN(translate.get('MESSAGE.M002'))]
                        }
                        required
                    />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`coResearcherName${language}`}
                        materialInputProps={{
                            disabled: disabled,
                            label:
                                language === 'TH'
                                    ? `${translate.get('LABEL.CO_RESEARCHER_NAME')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.CO_RESEARCHER_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                            placeholder:
                                language === 'TH'
                                    ? `${translate.get('LABEL.CO_RESEARCHER_NAME')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.CO_RESEARCHER_NAME')}​ (${translate.get('LABEL.ENG')}​)`,
                            size: 'small',
                            rows: 3,
                            multiline: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`detail${language}`}
                        materialInputProps={{
                            disabled: disabled,
                            label:
                                language === 'TH'
                                    ? `${translate.get('LABEL.CERTIFICATE_DETAIL')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.CERTIFICATE_DETAIL')}​ (${translate.get('LABEL.ENG')}​)`,
                            size: 'small',
                            rows: 5,
                            multiline: true,
                        }}
                        validates={
                            language === 'TH'
                                ? [textRequired(translate.get('MESSAGE.M015'))]
                                : [validateEN(translate.get('MESSAGE.M008'))]
                        }
                        required
                        // maxLength={1000}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`docCertificate${language}`}
                        materialInputProps={{
                            disabled: disabled,
                            label:
                                language === 'TH'
                                    ? `${translate.get('LABEL.DOC_TO_BE_CERTIFIED')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.DOC_TO_BE_CERTIFIED')}​ (${translate.get('LABEL.ENG')}​)`,
                            size: 'small',
                            rows: 5,
                            multiline: true,
                        }}
                        validates={
                            language === 'TH'
                                ? [textRequired(translate.get('MESSAGE.M015'))]
                                : [validateEN(translate.get('MESSAGE.M007'))]
                        }
                        // maxLength={1000}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`condition${language}`}
                        materialInputProps={{
                            disabled: disabled,
                            label:
                                language === 'TH'
                                    ? `${translate.get('LABEL.CONDITION')}​ (${translate.get('LABEL.THAI')}​)`
                                    : `${translate.get('LABEL.CONDITION')}​ (${translate.get('LABEL.ENG')}​)`,
                            size: 'small',
                            rows: 5,
                            multiline: true,
                        }}
                        validates={
                            language === 'TH'
                                ? [textRequired(translate.get('MESSAGE.M015'))]
                                : [validateEN(translate.get('MESSAGE.M006'))]
                        }
                        // maxLength={1000}
                        required
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

//Controller
const Certificate = (props: certificateTypes.CertificateType) => {
    const certificateModel = useHeadCertificate(props)
    return <CertificateView {...certificateModel} {...props} />
}

export default Certificate
